import { render, staticRenderFns } from "./NoTenant.vue?vue&type=template&id=5af450ac&scoped=true&"
import script from "@/views/Errors/NoTenant.ts?vue&type=script&lang=ts&"
export * from "@/views/Errors/NoTenant.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Errors/no-tenant.scss?vue&type=style&index=0&id=5af450ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af450ac",
  null
  
)

export default component.exports